<template>
  <div class="userManage">
    <div class="navMenu">
      <el-button type="primary"  size="small" @click="handleAddUser">添加</el-button>
      <el-button type="primary"  size="small" @click="handleLogout" style="margin-left: 90px">退出登陆</el-button>
    </div>
    <div class="userTable">
      <el-table
          :data="tableData"
          height="100%">
        <el-table-column prop="username" label="用户名称"></el-table-column>
        <el-table-column prop="usernickname" label="用户昵称"></el-table-column>
        <el-table-column prop="privilege" label="用户权限" :formatter="stateFormat" ></el-table-column>
        <el-table-column prop="email" label="用户邮箱" ></el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button @click="handleEdit(scope.$index, scope.row)" class="option-button" type="text" size="small">配置</el-button>
            <el-button @click="handleDelete(scope.$index, scope.row)" class="option-button" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
        v-model="dialogVisible"

        :title="`${dialogType}用户`"
        width="30%">
      <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="rules"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-form-item label="用户名：" prop="username">
          <el-input v-model="ruleForm.username"></el-input>
        </el-form-item>
        <el-form-item label="用户密码：" prop="password">
          <el-input v-model="ruleForm.password" placeholder="不修改密码置空即可，默认密码为123456"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称：" prop="usernickname">
          <el-input v-model="ruleForm.usernickname" placeholder="默认和用户名相同"></el-input>
        </el-form-item>
        <el-form-item label="用户权限：" prop="privilege"  >
          <el-input v-model="ruleForm.privilege" :disabled="ifdisable"  @click.native="redirectToConfigPrivilege(ruleFormRef)"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email"  >
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>

      </el-form>


      <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="success" @click="addNote(ruleFormRef)">确定</el-button
        >
      </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store";
import {useRoute, useRouter} from 'vue-router'
import axios from "axios";
import qs from 'qs'
import { ElMessageBox, ElMessage } from 'element-plus'
import {ref, onBeforeMount, reactive, computed, watch} from 'vue'
export default {
  name: "UserManage",
  setup() {
    let router = useRouter();
    let route = useRoute();
    let ifdisable = ref(false);
    let tableData = ref([{
      "username": "demo",
      "usernickname": "测试1",
      "privilege": "111",
      "email": "xxxx@bh.com"
    }])

    let dialogVisible = ref(false)
    let dialogType = ref('添加')
    let ruleFormRef = ref()

    const ruleForm = ref({
      username: '',
      usernickname: '',
      privilege: '',
      password:'',
      email:''
    })
    const rules = reactive({
      username: [
        {
          required: true, message: '请输入用户名', trigger: 'blur'
        }
      ],
      password: [
        {
          required: false, message: '输入密码或者置空', trigger: 'blur'
        }
      ],
      usernickname: [
        {
          required: false, message: '请输入用户昵称', trigger: 'blur'
        }
      ],
      privilege: [
        {
          required: false, message: '请输入用户权限', trigger: 'blur'
        }
      ],
      email: [
        {
          required: true, message: '请输入用户邮箱', trigger: 'blur'
        }
      ]
    })





    /**
     * 添加按钮点击
     */
    function handleAddUser() {
      ruleForm.value = {
        username: '',
        usernickname: '',
        privilege: '',
        password: ''
      };
      dialogVisible.value = true
      dialogType.value = '添加'
      ifdisable.value = true;
    }

    function handleLogout(){
      localStorage.setItem("username","");
      localStorage.setItem("password","");
      router.push("/Login")
    }
    /**
     * 修改按钮点击
     * @type {handleEdit}
     */
    let handleEdit = ((index, row) => {
      console.log(ifdisable.value);
      dialogType.value = '配置'
      ifdisable.value = false;
      dialogVisible.value = true
      ruleForm.value = {...row}
    })
    /**
     * 保存节点信息
     * @type {addNote}
     */
    let addNote = ((form) => {
      form.validate((valid) => {
        if (valid) {
          if(dialogType.value === '添加') {
            axios.post('/api1/register', ruleForm.value,{
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(res => {
              let data = res.data
              if(data.code === 200) {
                getTableData()
                dialogVisible.value = false
              } else {
                ElMessage.error(data.message)
              }
            })
          }
          else if(dialogType.value === '配置')  {
            axios.post('/api1/edituser', ruleForm.value,{
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(res => {
              let data = res.data
              if(data.code === 200) {
                getTableData()
                dialogVisible.value = false
              } else {
                ElMessage.error(data.message)
              }
            })
          }
          }
        else {
          ElMessage.error("数据校验失败，修改后上传")
        }
      })
    })

    let getTableData = (() => {
      axios.get('/api1/userData/getUserlist').then(res => {
        if(res.data.code === 200) {
          tableData.value = res.data.data
        }
        else {
          ElMessage.error(res.data.code +  res.data.message)

        }
      })
    })

    /**
     * 删除节点
     * @type {handleDelete}
     */
    let handleDelete = ((index, row) => {
      console.log('删除', row.username);
      axios.get(`/api1/deleteuser/${row.username}` ).then(res => {
        let data = res.data
        if(data.code === 200) {
          getTableData()
        } else {
          ElMessage.error(data.message)
        }
      })
    })

    onBeforeMount(() => {
      getTableData();
    })

    return {
      tableData,
      dialogVisible,
      ruleFormRef,
      ruleForm,
      rules,
      ifdisable,
      dialogType,
      handleAddUser,
      handleLogout,
      handleEdit,
      handleDelete,
      addNote
    }

    // 监听 dialogVisible 变化，清空表单数据
    watch(dialogVisible, (newValue) => {
      if (!newValue) {
        // 对话框关闭时重置表单数据为空
        ruleForm.value = {
          username: '',
          usernickname: '',
          privilege: '',
          password: ''
        };
        // 重置表单验证状态
        ruleFormRef.value.resetFields();
      }
    });
  },
  methods: {
    redirectToConfigPrivilege(form)
    {
      form.validate(valid => {
        if (valid) {
          // 表单验证通过，执行路由跳转

          store.state.username = form.model.username;
          store.state.password = form.model.password;
          store.state.usernickname = form.model.usernickname;
          store.state.privilege = form.model.privilege;

          // store.state.privilege =
          this.$router.push('/ConfigPrivilege');
        } else {
          // 表单验证不通过，显示错误提示
          this.$message.error("表单验证失败，请检查输入");
        }
      });
    },
    stateFormat(row,column,cellValue){
      // console.log(row,column,cellValue);
      if(!cellValue) return "";
      if(cellValue.length >12){
        return cellValue.slice(0,18) + "..."
      }
      return cellValue
    },
  }
}
</script>

<style lang="scss">
.userManage{
  display: flex;
  flex-direction: column;
  //width: 100%;
  height: calc(100vh - 50px);
  //overflow: hidden;
  //align-content: center;
  /*margin-bottom: 10px;*/
  background-color: #303749;
  .navMenu {
    height: 52px;
    background-color: #2c3242;
    position: relative;
    margin: 10px;
    .el-button:hover{
      border-color: #42b983;
      color: #42b983;
    }
    .el-button {
      position: absolute;
      background-color: #2C3242;
      border-color: #fff;
      top: 10px;
      left: 20px;

    }
  }
  //.noteTable {
  //  margin-top: 10px;
  //  margin-left: 10px;
  //  margin-right: 10px;
  //  background-color: #2c3242;
  //  height: 750px;
  //}
  .userTable {
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    background-color: #2c3242;
    height: 75%;
    .option-button:hover {
      color: #359186;
    }
    .option-button {
      color: white;
    }
    //去除表格最下面那条线
    .el-table::before{
      height: 0px;
    }
    .el-table {
      background-color: #2c3242;
      //去除表头下面那条线
      th.el-table__cell.is-leaf{
        border-bottom: 0px;
      }
      //设置排序图标的颜色
      // .descending .sort-caret.descending {
      //   border-top-color: #359186;
      // }
      // .ascending .sort-caret.ascending {
      //   border-bottom-color: #359186;
      // }
      .cell{
        text-align: center;
      }
      th{
        background-color: #2c3242;
        color: #fff;
        // border-right: 1px solid rgba(256, 256, 256, 0.5);
      }
      tr{
        background-color: #2c3242;
        color: #fff;
        td{
          border-bottom: 0px;
        }
      }
      tr:hover td{
        background-color: #2c3242 !important;
      }
    }
  }
  .el-dialog__header {
    background: #2c3242;
    .el-dialog__title {
      color: white;
    }
  }
  .el-dialog__body {
    background: #2c3242;
    .el-form-item__label {
      color: white;
    }
    .el-radio__label {
      color: white;
    }
    .el-input{
      .el-input__inner{
        background-color: #303749;
        color: #fff;
        border: 1px #fff solid;
      }
    }
    .el-input .el-input__inner.active{
      border: 1px red solid;
    }
  }
  .el-dialog__footer {
    background: #2c3242;
    border-top: 1px white solid;
    .el-button--success{
      background: #359186;
      border: 0;
    }

    .el-button--success:hover{
      background: #3a9f93;
    }

  }
}
</style>
